import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const CanonicalUrl = ({ title, description, type = 'website' }) => {
  const location = useLocation();
  
  // Base canonical domain - always use https://www.botimza.com (with www)
  const baseUrl = 'https://www.botimza.com';
  
  // Get clean pathname without query parameters
  const cleanPath = location.pathname;
  
  // Handle query parameters - only include specific allowed ones for SEO
  const searchParams = new URLSearchParams(location.search);
  const allowedParams = ['q']; // Only include search query in canonical
  const cleanParams = new URLSearchParams();
  
  allowedParams.forEach(param => {
    if (searchParams.has(param)) {
      cleanParams.set(param, searchParams.get(param));
    }
  });
  
  // Generate canonical URL
  const queryString = cleanParams.toString();
  const canonicalUrl = `${baseUrl}${cleanPath}${queryString ? `?${queryString}` : ''}`;
  
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:url" content={canonicalUrl} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
    </Helmet>
  );
};

export default CanonicalUrl; 